if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productForm = this.productSection.querySelector('product-form');

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    bindEvents() {
      // On desktop the store header stays fixed on screen, so the product's
      // add-to-cart button can be hidden behind it well before it crosses
      // the top of the viewport. Treat "scrolled past" as past the header.
      const header = document.querySelector('store-header[data-is-sticky="true"]');
      const headerHeight = (header && theme.mediaMatches.md) ? header.getBoundingClientRect().height : 0;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > headerHeight);
          }
        });
      }, { rootMargin: `-${headerHeight}px 0px 0px 0px` });

      if (this.productForm) observer.observe(this.productForm);

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}